// // // import logo from './logo.svg';
// // // import Dashboard from './pages/Dashboard';
// // // import { Box, List, ListItemButton, Tooltip } from '@mui/material';


// // // function App() {
// // //   return (
// // //     <Box sx={{ 
// // //       border: '10px solid #1a237e', // इमेजप्रमाणे गडद निळी बॉर्डर
// // //       height: '100vh',
// // //       overflow: 'hidden',
// // //       boxSizing: 'border-box'
// // //     }}>
// // //       <Dashboard />
// // //     </Box>
// // //   );
// // // }

// // // export default App;


// // import React from 'react';
// // import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// // import { Box } from '@mui/material';
// // import Dashboard from './pages/Dashboard';
// // import Login from './pages/Login'; // तुमचे नवीन लॉगिन पेज

// // function App() {
// //   return (
// //     <BrowserRouter>
// //       <Routes>
// //         {/* १. लॉगिन पेज - येथे ती निळी बॉर्डर नसेल (Clean Look) */}
// //         <Route path="/" element={<Login />} />

// //         {/* २. डॅशबोर्ड पेज - येथे तुमची सांगितलेली गडद निळी बॉर्डर असेल */}
// //         <Route 
// //           path="/dashboard" 
// //           element={
// //             <Box sx={{ 
// //               border: '10px solid #1a237e', // तुमची गडद निळी बॉर्डर
// //               height: '100vh',
// //               overflow: 'hidden',
// //               boxSizing: 'border-box'
// //             }}>
// //               <Dashboard />
// //             </Box>
// //           } 
// //         />

// //         {/* चुकीचा पाथ टाकला तर परत लॉगिनला पाठवा */}
// //         <Route path="*" element={<Navigate to="/" />} />
// //       </Routes>
// //     </BrowserRouter>
// //   );
// // }

// // export default App;

// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import MainLayout from './layout/MainLayout';
// import DashboardContent from './components/DashboardContent';
// import AddLeadForm from "./components/AddLeadForm";
// import Login from './pages/Login';
// import { Box } from '@mui/material';

// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<Login />} />

//         {/* Dashboard Group - Ithe border common rahil */}
//         <Route 
//           path="/dashboard" 
//           element={
//             <Box sx={{ border: '10px solid #1a237e', height: '100vh', boxSizing: 'border-box' }}>
//               <MainLayout />
//             </Box>
//           }
//         >
//           {/* Index mhanje /dashboard var hi content disel */}
//           <Route index element={<DashboardContent />} />
//           <Route path="inquiry" element={<AddLeadForm />} />
//           <Route path="leads" element={<DashboardContent />} />
          
//           {/* Section Placeholder */}
//           <Route path="*" element={<Box sx={{ p: 5 }}>Section Coming Soon...</Box>} />
//         </Route>

//         <Route path="*" element={<Navigate to="/" />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }
// export default App;

// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import MainLayout from './layout/MainLayout';
// import Dashboard from './pages/Dashboard'; // Navin design vala
// import DashboardContent from './components/DashboardContent'; // Lead Table
// import AddLeadForm from "./components/AddLeadForm";
// import Login from './pages/Login';
// import { Box } from '@mui/material';

// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<Login />} />

//         {/* Common Layout with Blue Border */}
//         <Route 
//           path="/dashboard" 
//           element={
//             <Box sx={{ border: '10px solid #1a237e', height: '100vh', boxSizing: 'border-box', overflow: 'hidden' }}>
//               <MainLayout />
//             </Box>
//           }
//         >
//           {/* Outlet madhe he render hotil */}
//           <Route index element={<Dashboard />} /> 
//           <Route path="inquiry" element={<AddLeadForm />} />
//           <Route path="leads" element={<DashboardContent />} />
//         </Route>

//         <Route path="*" element={<Navigate to="/" />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import Dashboard from './pages/Dashboard'; // Navin design vala
import DashboardContent from './components/DashboardContent'; // Lead Table
import AddLeadForm from "./components/AddLeadForm";
import InquiryDetails from "./components/InquiryDetails"
import Login from './pages/Login';
import { Box } from '@mui/material';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        {/* Common Layout with Blue Border */}
        <Route 
          path="/dashboard" 
          element={
            <Box sx={{ border: '10px solid #1f0b7c', height: '100vh', boxSizing: 'border-box', overflow: 'hidden' }}>
              <MainLayout />
            </Box>
          }
        >
          {/* Outlet madhe he render hotil */}
          <Route index element={<Dashboard />} /> 
          <Route path="inquiry" element={<AddLeadForm />} />
          <Route path="inquiry-details" element={<InquiryDetails />} />
          <Route path="leads" element={<DashboardContent />} />
        </Route>

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;